import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IAction } from "reduxsauce";

import { Creators as AllCreators } from "../../actions";
import * as selectors from "../../selectors/selectors";
import { IState } from "../reducer";
import { RequestState } from "../types/common";
import * as actions from "./actions";
import { ClassesComponent } from "./Classes.component";
import { IClassesDispatchProps, IClassesStateProps } from "./types";

const Creators = (AllCreators as any).App.Classes;

const mapStateToProps = (state: IState): IClassesStateProps => ({
  accountId: selectors.accountId(state),
  classes: selectors.classes(state),
  deleteClassRequestError: state.App.Classes._.deleteClassRequestError,
  fetchAllClassesRequestError: state.App.Classes._.fetchAllClassesRequestError,
  isAuthenticated: state.App._.authenticationState.isAuthenticated,
  isLoading: getIsLoading(state),
  organizationName: selectors.organizationName(state),
  userName: selectors.accountName(state),
});

const mapDispatchToProps = (dispatch: Dispatch<IAction>): IClassesDispatchProps => ({
  addNewClass: () => dispatch(actions.addNewClass()),
  deleteClass: (classId: string) => () => dispatch(Creators.deleteClass(classId)),
  mount: () => {
    dispatch(Creators.mount());
    dispatch(actions.fetchAllClasses());
  },
  unmount: () => dispatch(Creators.unmount()),
});

export const Classes = connect(mapStateToProps, mapDispatchToProps)(ClassesComponent);

function getIsLoading(state: IState) {
  return (
    !state.App._.authenticationState.isKnown ||
    !selectors.isAdminUser(state) ||
    state.App.Classes._.fetchAllClassesRequestState !== RequestState.SUCCEEDED ||
    state.App.Classes._.deleteClassRequestState === RequestState.PENDING ||
    state.App.Classes._.addNewClassRequestState === RequestState.PENDING
  );
}
